








import Vue from 'vue';

export default Vue.extend({
  props: {
    spacer: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    btnClasses(): { [key: string]: boolean } {
      return {
        'white--text': this.spacer,
        'grey--text': !this.spacer,
        'text--lighten-2': !this.spacer
      };
    },
    iconColor(): string | null {
      return this.spacer ? null : 'blue';
    }
  },

  methods: {
    click() {
      this.$emit('click');
    }
  }
});
